var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.21967 3.21967C7.51256 2.92678 7.98744 2.92678 8.28033 3.21967L16.2803 11.2197C16.5732 11.5126 16.5732 11.9874 16.2803 12.2803L8.28033 20.2803C7.98744 20.5732 7.51256 20.5732 7.21967 20.2803C6.92678 19.9874 6.92678 19.5126 7.21967 19.2197L14.6893 11.75L7.21967 4.28033C6.92678 3.98744 6.92678 3.51256 7.21967 3.21967Z",
    fill: "#000928"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.ae196374adbf69e5ba82ed9d5ade81cf.svg";
export { ForwardRef as ReactComponent };